export default __webpack_public_path__ + "media/images/mailer-new/common/header-bg-start-a2aacb4f9e131a9f4132c0f037ce27dc.png";